import { updateFilterQuery, queryParser } from 'Utils/routerUtils'
import * as R from 'ramda'
import debounce from 'lodash.debounce'
import {
  CHECKBOX_GROUP_LIST,
  CHECKBOX_LIST,
  SLIDER,
  INPUT,
  AUTOCOMPLETE_INPUT,
  CHECKBOX,
  RADIO_LIST,
  DROPDOWN,
  DROPDOWN_BOX_SELECT,
  DROP_DOWN_SLIDER,
  UP_DOWN_NUMBER_BOX,
  MULTI_SELECT_BOXES,
  TOGGLE_BOXES,
  PERIOD_DROPDOWN,
} from 'Defaults/filters'
import { isNilEmpty } from 'Utils'

const MAX_SLIDER_VALUE = 999999999

const debouncedUpdateFilterQuery = debounce((key, value, googleAnalyticsEvent, checkHideState) => {
  checkHideState(key, value)
  updateFilterQuery(key, value && !R.isEmpty(value) ? [value] : [])
  const actions = [
    'Filter Updated',
    `${key}`,
  ]
  if(!isNilEmpty(value)) {
    actions.push(value[value.length - 1])
  }
  googleAnalyticsEvent({
    category: 'search',
    action: actions,
  })
}, 250)
// generate event handler depends on component name
const eventHandlerFactory = (
  componentData,
  componentName,
  inputName,
  googleAnalyticsEvent,
  checkHideState,
) => {
  switch(componentName) {
    case TOGGLE_BOXES:
      return value => debouncedUpdateFilterQuery(inputName, [value], googleAnalyticsEvent, checkHideState)
    case UP_DOWN_NUMBER_BOX:
      return (value) => debouncedUpdateFilterQuery(inputName, value, googleAnalyticsEvent, checkHideState)
    case MULTI_SELECT_BOXES:
      return (values) => {
        debouncedUpdateFilterQuery(inputName, values, googleAnalyticsEvent, checkHideState)
      }
    case DROPDOWN_BOX_SELECT:
      return ((e, value) => {
        debouncedUpdateFilterQuery(inputName, value ? [value] : [], googleAnalyticsEvent, checkHideState)
      })
    case PERIOD_DROPDOWN:
      return ({ value }) => {
        const time = value.split(',')[1]
        let newVals = [value]
        if(time === '-1') newVals = null
        debouncedUpdateFilterQuery(inputName, newVals, googleAnalyticsEvent, checkHideState)
      }
    case DROPDOWN:
      return ({ value }) => {
        let newVals = [value]
        if(R.contains('-1', newVals)) {
          newVals = null
        }
        debouncedUpdateFilterQuery(inputName, newVals, googleAnalyticsEvent, checkHideState)
      }

    case INPUT:
      return (value) => {
        debouncedUpdateFilterQuery(inputName, value, googleAnalyticsEvent, checkHideState)
      }
    case AUTOCOMPLETE_INPUT:
      return (values) => {
        debouncedUpdateFilterQuery(inputName, values, googleAnalyticsEvent, checkHideState)
      }
    case SLIDER:
    case DROP_DOWN_SLIDER:
      return (values) => {
        if(!values) debouncedUpdateFilterQuery(inputName, null, googleAnalyticsEvent)
        const intervals = componentData.intervals && componentData.intervals.length ? componentData.intervals : null

        const defaultMin = intervals ? intervals[0].min : null
        const isMaxDefined = values && values[1]
        const isMinDefined = values && values[0] !== defaultMin

        const newVal = (isMaxDefined || isMinDefined) ? values : ''
        if(isMinDefined && !isMaxDefined) newVal[1] = MAX_SLIDER_VALUE
        debouncedUpdateFilterQuery(inputName, newVal, googleAnalyticsEvent, checkHideState)
      }
    case RADIO_LIST:
      return (valueArr) => {
        let newVals = valueArr
        if(R.contains('-1', valueArr)) {
          newVals = null
        }
        debouncedUpdateFilterQuery(inputName, newVals, googleAnalyticsEvent, checkHideState)
      }
    case CHECKBOX:
      return () => {
        const searchQuery = queryParser()
        const inputNameExist = !!searchQuery[inputName]
        const newValue = inputNameExist ? '' : 1
        debouncedUpdateFilterQuery(inputName, newValue, googleAnalyticsEvent, checkHideState)
      }
    case CHECKBOX_LIST:
      return (valueArr) => {
        let newVals = valueArr
        if(R.contains('-1', valueArr)) {
          newVals = null
        }
        debouncedUpdateFilterQuery(inputName, newVals, googleAnalyticsEvent, checkHideState)
      }
    case CHECKBOX_GROUP_LIST:
      return {
        parentCheckboxHandler: (values) =>
          debouncedUpdateFilterQuery(inputName, values, googleAnalyticsEvent, checkHideState),
        subCheckboxListHandler: (values) =>
          debouncedUpdateFilterQuery(inputName, values, googleAnalyticsEvent, checkHideState),
      }
      // return {
      //   parentCheckboxHandler: (valueArr, shouldAdd) => {
      //     const searchQuery = queryParser()
      //     const checkboxGroupVals =
      //       searchQuery[inputName] ? searchQuery[inputName].split(',') : []
      //     if(shouldAdd) {
      //       const newVals = R.uniq([...valueArr, ...checkboxGroupVals])
      //       return debouncedUpdateFilterQuery(inputName, newVals, googleAnalyticsEvent)
      //     }
      //     // remove valueArr from checkboxGroupVals
      //     const removedSelectedVals = R.without(valueArr, checkboxGroupVals)
      //     return debouncedUpdateFilterQuery(inputName, removedSelectedVals, googleAnalyticsEvent)
      //   },
      //   subCheckboxListHandler: (value, shouldRemove) => {
      //     const searchQuery = queryParser()
      //     const checkboxGroupVals =
      //       searchQuery[inputName] ? searchQuery[inputName].split(',') : []
      //     if(shouldRemove) {
      //       const removedSelectedVal = R.without(value, checkboxGroupVals)
      //       return debouncedUpdateFilterQuery(inputName, removedSelectedVal, googleAnalyticsEvent)
      //     }
      //     const newVals = R.uniq([value, ...checkboxGroupVals])
      //     return debouncedUpdateFilterQuery(inputName, newVals, googleAnalyticsEvent)
      //   },
      // }
  }
  return () => {}
}

export default eventHandlerFactory
